<div>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Emissão de DAS</h4>
        <span title="Fechar" aria-hidden="true" class="pull-right material-icons icon-24 cursor" (click)="responder('fechar')">close</span>
    </div>
    <iframe #iframe class="das-dialog">    
    </iframe>    
</div>
